import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Person = ({
  height = 21,
  width = 17,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 17 21" {...props}>
    <path
      d="M3.02699 5.87829C3.02699 8.61102 5.29726 10.9233 8.21617 10.9233C11.1351 10.9233 13.4054 8.71612 13.4054 5.87829C13.4054 3.04046 10.9189 0.833252 8.10807 0.833252C5.29726 0.833252 3.02699 3.04046 3.02699 5.87829Z"
      fill={getColor(color, isColorInherited)}
      stroke={getColor(color, isColorInherited)}
    />
    <path
      d="M8.10809 11.8693C3.67567 11.8693 0 15.4429 0 19.7522C0 20.0675 0.216216 20.2777 0.54054 20.2777H15.6756C16 20.2777 16.2162 20.0675 16.2162 19.7522C16.2162 15.4429 12.5405 11.8693 8.10809 11.8693Z"
      fill={getColor(color, isColorInherited)}
      stroke={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
